<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const ORIENTATIONS = [
  { value: 'horizontal', label: t('site.f.steps.opt_across', 'Across') },
  { value: 'vertical', label: t('site.f.steps.opt_down', 'Down') }
] as const

const addStep = () => {
  props.block.data.steps = [...(props.block.data.steps ?? []), { title: '', description: '' }]
}
const removeStep = (i: number) => {
  props.block.data.steps?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.intro_optional', 'Intro (optional)')">
    <UTextarea
      v-model="block.data.subtext"
      :rows="2"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.steps.direction', 'Direction')">
    <SiteEditorOptionToggle
      :options="ORIENTATIONS"
      :model-value="block.data.orientation ?? 'horizontal'"
      @update:model-value="block.data.orientation = $event as 'vertical' | 'horizontal'"
    />
  </UFormField>

  <SiteEditorArrayItemCard
    v-for="(step, i) in block.data.steps ?? []"
    :key="i"
    :label="`${t('site.f.steps.item_label', 'Step')} ${i + 1}`"
    @remove="removeStep(i)"
  >
    <UInput
      v-model="step.title"
      :placeholder="t('site.f.steps.step_title', 'Step title')"
      class="w-full"
    />
    <UTextarea
      :model-value="step.description ?? ''"
      :rows="2"
      :placeholder="t('site.f.steps.what_happens_in_this_step', 'What happens in this step')"
      class="w-full"
      @update:model-value="step.description = String($event)"
    />
    <SiteEditorImagePicker
      :label="t('site.f.common.image_label', 'Image')"
      :model-value="step.image ?? ''"
      @update:model-value="step.image = $event"
    />
  </SiteEditorArrayItemCard>

  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addStep"
  >
    {{ t('site.f.steps.add_item', 'Add step') }}
  </UButton>
</template>
